"use client";
// import MainFilterSearchBox from "./MainFilterSearchBox";
import Image from "next/image";
import BG_NEW_200_IMG from "@/img/andrei-ionov-lomeBgTG6U4-unsplash-new-200kb.webp";
import useMediaQuery from "@/hooks/useMediaQuery";
import SearchModal from "@/components/search/SearchModal";
import { useCallback, useEffect, useState } from "react";

import MainFilterSearchBox from "@/components/hotel-listing-v2/ui/SearchBar/MainFilterSearchBox";
import "./MainImage.css";
const index = () => {
  // const isDesktop = useMediaQuery("(min-width: 992px)");
  const [isSearchModalOpen, setIsSearchModalOpen] = useState<boolean>(false);

 /*const openSearchModal = useCallback(() => {
    if (isDesktop == false) {
      setIsSearchModalOpen(true);
    } else {
      setIsSearchModalOpen(false);
    }
  }, [isDesktop]);

  // Effect to close modal when switching to desktop mode
  useEffect(() => {
    if (isDesktop && isSearchModalOpen) {
      setIsSearchModalOpen(false); // Close modal when screen becomes desktop
    }
  }, [isDesktop, isSearchModalOpen]);*/

  const openSearchModal = useCallback(() => {
    console.log("window.innerWidth", window.innerWidth);
    if (window.innerWidth < 992) {
      setIsSearchModalOpen(true);
    }
  }, []);

  useEffect(() => {
    const handler = () => {
      if (window.innerWidth >= 992) {
        setIsSearchModalOpen(false);
      }
    };
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);


  return (
    <>
      <SearchModal
        isOpen={isSearchModalOpen}
        setIsOpen={setIsSearchModalOpen}
      />
     
      <section className="masthead -type-1 z-5">
        <div className="masthead__bg desktop-only">
          {/* {isSearchModalOpen && ( */}
            <Image
              // className="js-lazy"
              alt="background image"
              src={BG_NEW_200_IMG}
              priority={true}
              quality={50}
              fill
              placeholder="blur"
              onLoadingComplete={(img) =>
                img.setAttribute("data-loaded", "true")
              }
            />
          {/* )}  */}
        </div>
       
        <div className="container">
          <div className="row justify-center">
            <div className="home-hero-content col-auto">
              <div className="text-center">
                <h1
                  className="text-60 lg:text-40 md:text-30 text-white"
                  // data-aos="fade-up"
                >
                  Find hotel deals before prices move
                </h1>
                <p
                  className="text-white mt-6 md:mt-10"
                  // data-aos="fade-up"
                  // data-aos-delay="100"
                >
                  Compare trusted stays, member rates, and flexible options in seconds.
                </p>
              </div>
              {/* End hero title */}

              <div
                className="tabs -underline mt-60 js-tabs"
                // data-aos="fade-up"
                // data-aos-delay="10"
                onClick={openSearchModal}
              >
                <div className="position-relative mt-30 md:mt-20 js-tabs-content">
                  <MainFilterSearchBox requestFrom="home" />
                </div>
              </div>
              {/* End tab-filter */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default index;
